import { useDebounce } from "@api";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { type ChangeEvent, useEffect, useState } from "react";
import type { IAddParticipantFilters, IFilterInputProps } from "./types";

export const FilterSearchBar = ({ value, dispatch }: IFilterInputProps<IAddParticipantFilters["search"]>) => {
  const [localValue, setLocalValue] = useState(value);

  const handleDebounce = useDebounce(
    (value: string) => {
      if (value.length >= 2 || value.length === 0) {
        dispatch({ type: "search", payload: value });
      }
    },
    500,
    [dispatch]
  );

  const handleChange = (evt: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setLocalValue(evt.target.value);
    handleDebounce(evt.target.value);
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <TextField
      placeholder="Rechercher manuellement"
      value={localValue}
      onChange={handleChange}
      size="small"
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="secondary" />
            </InputAdornment>
          ),
        }
      }}
    />
  );
};
